import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialogState, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty as empty } from 'lodash';
import { Editor } from 'primeng/editor';

@Component({
  selector: 'app-text-editor-dialog',
  templateUrl: './text-editor-dialog.component.html',
  styleUrls: ['./text-editor-dialog.component.scss']
})
export class TextEditorDialogComponent implements AfterViewInit {

  @ViewChild('editor')
  ngTextEditor: Editor;

  editorHeight = '100px';
  htmlOutput: string = '';
  private textEditorDialogOutput: TextEditorDialogOutput | null = null;

  constructor(public dialogRef: MatDialogRef<TextEditorDialogComponent>, private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public input: TextEditorDialogOutput, private translateServis: TranslateService) { }

  ngAfterViewInit(): void {
    this.setupEditorHeight();
    this.setupEditorView();
    window.addEventListener('resize', () => this.setupEditorHeight());
    this.dialogRef.backdropClick().subscribe(() => this.close());
    if (this.input?.htmlOutput)
      this.htmlOutput = this.input.htmlOutput;
    this.cd.detectChanges();
  }

  setupEditorView(): void {
    const toolbar: HTMLElement = document.querySelector('.ql-toolbar');
    const toolbarOptions: HTMLCollection = toolbar.children;

    const headerAndFont = toolbarOptions[0];
    const selectFontSizePickerHeader = document.querySelectorAll('.ql-picker-label')[0];
    selectFontSizePickerHeader.setAttribute('data-label', this.translateServis.instant('normal'));
    let selectFontSizePickerOptions = null;
    let selectFontSizePickerIndex = 0;
    while (selectFontSizePickerIndex < 1000 && document.querySelector('#ql-picker-options-' + selectFontSizePickerIndex) == null)
      selectFontSizePickerIndex++;
    selectFontSizePickerOptions = document.querySelector('#ql-picker-options-' + selectFontSizePickerIndex)?.children;
    selectFontSizePickerOptions[0]?.setAttribute('data-label', this.translateServis.instant('large'));
    selectFontSizePickerOptions[1]?.setAttribute('data-label', this.translateServis.instant('medium'));
    selectFontSizePickerOptions[2]?.setAttribute('data-label', this.translateServis.instant('normal'));

    headerAndFont.removeChild(headerAndFont.children[2]);
    // const fontOptions = toolbarOptions[1]; for later use
    const colorText = toolbarOptions[2];
    const backgroundColor = colorText.children[2];
    colorText.removeChild(backgroundColor);
    const lists = toolbarOptions[3];
    const media = toolbarOptions[4];
    const removeStyles = toolbarOptions[5];
    toolbar.removeChild(lists);
    toolbar.removeChild(media);
    toolbar.removeChild(removeStyles);
  }

  createTextEditorDialogOutput(): void {
    const expresions: { insert: string; attributes: Record<string, string | boolean> }[] = this.ngTextEditor.getQuill().editor.delta.ops;
    const pureString = expresions
      .map(exp => exp.insert)
      .map(exp => exp.replace(/\n/g, ''))
      .join(' ');
    this.textEditorDialogOutput = new TextEditorDialogOutput(this.htmlOutput, pureString);
  }

  setupEditorHeight(): void {
    if (this.dialogRef.getState() === MatDialogState.OPEN) {
      const element: HTMLElement = document.querySelector('#editor-container');
      const style = window.getComputedStyle(element);
      this.ngTextEditor.onModelChange();
      this.editorHeight = (parseInt(style.height.replace('px', '')) - 50) + 'px';
      this.cd.detectChanges();
    }
  }

  @HostListener('window:keyup.esc')
  onKeyUp(): void {
    this.dialogRef.close(this.input);
  }

  clearClose(): void {
    this.dialogRef.close(new TextEditorDialogOutput(null, null));
  }

  close(): void {
    this.dialogRef.close(this.input);
  }

  submit(): void {
    this.createTextEditorDialogOutput();
    this.dialogRef.close(this.textEditorDialogOutput);
  }

}

export class TextEditorDialogOutput {
  htmlOutput: string | null = null;
  pureStringOutput: string | null = null;

  constructor(htmlOutput: string, pureStringOutput: string) {
    this.htmlOutput = htmlOutput;
    this.pureStringOutput = pureStringOutput;
  }

  isEmpty(): boolean {
    return empty(this.htmlOutput) || empty(this.pureStringOutput);
  }
}
